import { produce } from 'immer';

const initialState = {
  alerts: {},
  dismissedTips: [],
  dismissedAdverts: [],
  dismissedStatementReminders: [],
  dismissedDDPaymentsFailed: [],
};

const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'DISMISS_ADVERT': {
      return produce(state, draft => {
        let advert = draft.dismissedAdverts.find(
          r => r.shortCode === action.shortCode && r.name === action.name,
        );

        if (!advert) {
          advert = {
            shortCode: action.shortCode,
            name: action.name,
            dismissedByUser: action.dismissedByUser,
          };
          draft.dismissedAdverts.push(advert);
        }
      });
    }
    case 'DISMISS_TIP_ALERT': {
      return produce(state, draft => {
        let tip = draft.dismissedTips.find(
          r => r.shortCode === action.shortCode && r.name === action.name,
        );

        if (!tip) {
          tip = {
            shortCode: action.shortCode,
            name: action.name,
          };
          draft.dismissedTips.push(tip);
        }
      });
    }
    case 'UPSERT_ALERT': {
      const alert = Object.assign({}, state.alerts[action.name], action.alert);
      const newAlerts = Object.assign({}, state.alerts, {
        [action.name]: alert,
      });
      return { ...state, alerts: newAlerts };
    }
    case 'DISMISS_STATEMENT_REMINDER': {
      return produce(state, draft => {
        let reminder = draft.dismissedStatementReminders.find(
          r => r.shortCode === action.shortCode && r.time === action.time,
        );
        if (!reminder) {
          reminder = {
            shortCode: action.shortCode,
            time: action.time,
          };
          draft.dismissedStatementReminders.push(reminder);
        }
        reminder[action.which] = true;

        // cleanup old dismissed reminders, otherwise, because it's persisted,
        // the state will grow indefinitely
        const now = Date.now();
        draft.dismissedStatementReminders = draft.dismissedStatementReminders.filter(
          r => now <= r.time,
        );
      });
    }
    case 'DISMISS_DIRECT_DEBIT_PAYMENT_FAILED_NOTICE': {
      return produce(state, draft => {
        const reminder = draft.dismissedDDPaymentsFailed.find(
          r =>
            r.shortCode === action.shortCode &&
            r.invoiceId === action.invoiceId &&
            r.time === action.time,
        );

        if (!reminder) {
          const newReminder = {
            shortCode: action.shortCode,
            invoiceId: action.invoiceId,
            time: action.time,
          };
          draft.dismissedDDPaymentsFailed.push(newReminder);
        }
      });
    }
    default: {
      return state;
    }
  }
};

export default alertReducer;
